import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "role-guide" }
const _hoisted_2 = { class: "role-overview" }
const _hoisted_3 = { class: "role-portraits" }
const _hoisted_4 = {
  key: 0,
  class: "role-credits"
}
const _hoisted_5 = { class: "wiki-panel" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "role-scenarios" }

import type { PropType } from 'vue';
import { computed } from 'vue';
import type { TRoles } from '@avalon/types';
import SchemaImage from '@/components/view/SchemaImage.vue';
import LocalizedTextWrapper from '@/components/feedback/LocalizedTextWrapper.vue';
import { calculateRoleUrl } from '@/helpers/styles';
type GuideRole =
  | Exclude<TRoles, 'merlin' | 'tristan' | 'isolde' | 'goodLancelot' | 'evilLancelot' | 'wraith'>
  | 'lancelots'
  | 'lovers';

export default /*@__PURE__*/_defineComponent({
  __name: 'WikiRoleGuide',
  props: { role: { type: String as PropType<GuideRole>, required: true } },
  setup(__props) {

const props = __props;
const portraits = computed<TRoles[]>(() => {
  if (props.role === 'lancelots') return ['goodLancelot', 'evilLancelot'];
  if (props.role === 'lovers') return ['tristan', 'isolde'];
  return [props.role];
});
const facts = [
  { label: 'roleTeam', key: 'seoTeam' },
  { label: 'roleAbility', key: 'seoAbility' },
  { label: 'roleLimit', key: 'seoLimit' },
];

return (_ctx: any,_cache: any) => {
  const _component_LocaleLink = _resolveComponent("LocaleLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(portraits.value, (portrait) => {
          return (_openBlock(), _createBlock(SchemaImage, {
            key: portrait,
            class: "role-portrait",
            role: portrait,
            src: _unref(calculateRoleUrl)(portrait),
            alt: _ctx.$t(`roles.${portrait}`),
            description: _ctx.$t(`roles.${portrait}`)
          }, null, 8, ["role", "src", "alt", "description"]))
        }), 128)),
        (__props.role === 'lovers' || __props.role === 'guinevere')
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t(`${__props.role}.credits`)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.roleFacts')), 1),
        _createElementVNode("dl", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(facts, (fact) => {
            return _createElementVNode("div", {
              key: fact.key,
              class: "role-fact"
            }, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$t(`wiki.${fact.label}`)), 1),
              _createElementVNode("dd", null, [
                _createVNode(LocalizedTextWrapper, {
                  keypath: `${__props.role}.${fact.key}`
                }, null, 8, ["keypath"])
              ])
            ])
          }), 64))
        ]),
        _createElementVNode("nav", {
          class: "wiki-nav",
          "aria-label": _ctx.$t('wiki.title')
        }, [
          _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('wiki.rules')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('wiki.rolesTitle')), 1)
            ]),
            _: 1
          })
        ], 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.roleScenarios')), 1),
      _createElementVNode("ul", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (number) => {
          return _createElementVNode("li", { key: number }, [
            _createVNode(LocalizedTextWrapper, {
              keypath: `${__props.role}.seoScenario${number}`
            }, null, 8, ["keypath"])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})